type AnyObject = Record<string, unknown>;

/**
 * Recursively picks keys from `source` that exist in `template`.
 * For nested plain objects, only the matching nested keys are picked.
 * Arrays and non-object values are copied directly.
 */
export default function deepPick(source: AnyObject, template: AnyObject): AnyObject {
  const result: AnyObject = {};
  for (const key of Object.keys(template)) {
    const tVal = template[key],
      sVal = source[key];
    if (
      tVal !== null &&
      typeof tVal === "object" &&
      !Array.isArray(tVal) &&
      sVal !== null &&
      typeof sVal === "object" &&
      !Array.isArray(sVal)
    ) {
      result[key] = deepPick(sVal as AnyObject, tVal as AnyObject);
    } else {
      result[key] = sVal;
    }
  }
  return result;
}
